import React from "react"

export function ConditionalLink({ children, href }) {
  const handleClick = e => {
    e.preventDefault()
  }

  return href ? (
    <a href={href} onClick={handleClick}>
      {children}
    </a>
  ) : (
    <>{children}</>
  )
}
